<style scoped lang="sass">
.app_container
  display: flex
  flex-direction: column
  justify-content: space-between

  .top_component
    flex: 1

.header_container
  height: 136px

  .header_body
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    height: 100%
    background: rgba(0, 0, 0, 0.6)
    color: #fff
    text-align: center
    font-size: 10px

    .status
      display: flex
      align-items: center
      justify-content: center

      .circle
        margin-right: 2px
        display: block
        border-radius: 50%
        width: 10px
        height: 10px
        background: #17A341

      .close_circle
        background: red

    .code
      font-size: 50px
      font-weight: bold
      line-height: 60px

    .no_amount_wrap
      .status
        font-size: 18px
        font-weight: bold

        .circle
          margin-right: 6px
          width: 18px
          height: 18px

      .text
        margin-top: 20px
        font-size: 12px

.desc_container
  display: flex
  justify-content: space-around
  padding: 20px 0

  .top_button_box
    display: flex
    flex-direction: column
    align-items: center
    width: 56px
    cursor: pointer

    .top_button
      display: flex
      justify-content: center
      align-items: center
      width: 56px
      height: 56px
      border: 1px solid rgba(50, 56, 62, .1)
      border-radius: 50%

    .top_button_title
      margin-top: 6px
      font-size: 12px
      color: #334455
      white-space: nowrap

.amount_container
  display: flex
  justify-content: center
  align-items: center
  height: 75px
  border-top: 1px solid rgba(50, 56, 62, 0.1)
  border-bottom: 1px solid rgba(50, 56, 62, 0.1)
  background: rgba(50, 56, 62, 0.02)
  font-size: 12px
  color: #345
  text-align: center

  .line
    width: 1px
    height: 55px
    background: rgba(50, 56, 62, 0.1)

  .tab_wrap
    flex: 1

    .num
      margin-top: 9px
      font-size: 20px
      font-weight: bold

.btn_list
  padding: 0 16px
  margin-bottom: 25px

  .van-button
    margin-top: 16px

    &:first-child
      margin-top: 0

  ::v-deep
    .van-button--primary
      height: 54px
      font-weight: bold
      border-radius: 5PX !important
</style>

<style lang="sass" scoped>
$color: var(--menu-primary-text-colour)
$bgc: var(--menu-primary-background-colour)
$disabed: #c5c7c8

.footer_component
  margin-top: 35px

.update
  background: #fff !important
  color: $bgc
  border: $bgc 1px solid

.increase
  background: #fff !important
  color: $bgc
  border: $bgc 1px solid

.close
  background: $bgc
  color: #fff
  border: none
  border-radius: 5PX !important

.history_icon
  height: 60px
  width: 60px
  display: flex
  justify-content: center
  align-items: center
  z-index: 2
  position: fixed
  top: 0
  right: 0

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .van-button--disabled
    opacity: 1
    background: $disabed
</style>

<template lang="pug">
.app_container
  .top_component
    .header_container(v-bg-cover="logo")
      .header_body
        .wrap(v-if="tabDetail.isSetTabAmount")
          span TAB CODE
          .code(:style="{ visibility: tabDetail.status >= 3 ? 'hidden' : 'visible' }") {{ tabDetail.tabCode }}
          .status(v-if="tabDetail.status === 2")
            i.circle
            | Your tab is open
          .status(v-else-if="tabDetail.status < 2") Start time: {{ startTime }}
          .status(v-else-if="tabDetail.status >= 3")
            i.circle.close_circle
            | Your tab is closed
        .no_amount_wrap(v-else)
          .status
            i.circle
            | Your tab is open
          .text Set a tab limit to share your tab with others.

    .desc_container(v-if="showTabButton")
      .top_button_box(@click="increaseAmount")
        .top_button
          icon(size="24") publish
        .top_button_title {{ tabDetail.isSetTabAmount ? 'Increase' : 'Set' }} limit
      .top_button_box(@click="jumpToTabHistory")
        .top_button
          icon(size="24") receipt_long
        .top_button_title Order history
      .top_button_box(@click="handleCopy($event)")
        .top_button
          icon(size="24") share
        .top_button_title Share tab code

    .amount_container(v-if="!tabDetail.isSetTabAmount")
      .tab_wrap
        span Current tab amount
        .num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ fmtDec(parseFloat(tabDetail.tabAmount)) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

    .amount_container(v-else-if="tabDetail.status <= 2")
      .tab_wrap
        span Tab amount
        .num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ fmtDec(parseFloat(tabDetail.tabAmount)) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

      .line

      .tab_wrap
        span Amount remaining
        .num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ amountRemaining }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

    .amount_container(v-else-if="tabDetail.status >= 3")
      .tab_wrap
        span Tab final amount
        .num {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ tabDetail.paidAmount ? fmtDec(tabDetail.paidAmount) : ''}}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

  .footer_component
    .btn_list(v-if="tabDetail.status < 3")
      van-button.update(
        v-if="showUpdateDetail"
        size="large"
        type="primary"
        plain
        @click="updateTabDetail"
      ) UPDATE YOUR DETAILS
      van-button.update(
        size="large"
        type="primary"
        plain
        @click="goToMenu"
      ) GO TO MENU
      van-button.close.b(
        size="large"
        :disabled="!isTabOpen "
        @click="showCloseTabComponent"
        style="height: 1.5rem"
      ) CLOSE TAB

  bottom-popup-dialog(v-model="showCloseTab")
    template(v-slot:popup-dialog)
      close-tab(
        :amount="tabDetail.amount"
        :minAmount="tabDetail.minAmount"
        @closeTab="closeTab"
      )

  bottom-popup-dialog(v-model="showIncreaseTab")
    template(v-slot:popup-dialog)
      increase-tab(
        :showIncreaseTab="showIncreaseTab"
        :isSetTabAmount="tabDetail.isSetTabAmount"
        :tabAmount="tabDetail.tabAmount"
        :tabDetailType="tabDetail.type"
        @submit="submitIncreaseTab"
      )
  mask-manage-tab(
    :showMask.sync="showMaskTip"
    :manageTitle="tipTitle"
    :manageTabText="tipContent"
  )
  py-loading(:showLoading="showLoading")
  tab-manage-popup-dialog(
    v-model="showDisableSetLimit"
    isFlexColumn
    :title="showDisableSetLimitSettings.title"
    :content="showDisableSetLimitSettings.content"
    :first-button-text="showDisableSetLimitSettings.firstButtonText"
    :second-button-text="showDisableSetLimitSettings.secondButtonText"
    @clickHandlerFirstButton="increaseAmount"
    @clickHandlerSecondButton="showDisableSetLimit = false"
  )

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import clip from '@/utils/clipboard'
import CloseTab from './components/CloseTheTab'
import IncreaseTab from './components/IncreaseTab'
import { loading } from 'utils/decorators'
import { _formatTime, safeDecodeURI } from 'utils'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { getTabDetail, updateTab } from 'api/tab'
import {
  closeTabSuccess,
  ready,
  tab_insufficient_fund_increase_tab,
  tab_insufficient_fund_payment,
  tabCopyCode
} from 'utils/message'
import { getVenue } from '@/api/product'
import MaskManageTab from 'components/MaskManageTab'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  components: {
    CloseTab,
    IncreaseTab,
    MaskManageTab,
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    }
  },

  computed: {
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo
    }),

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class TabMenu extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  fmtDec(val) { return formatDecimalNumber(val) }

  tipTitle = 'Tip'
  tipContent = 'Click here for easy access to the menu, or to manage your tab.'
  showMaskTip = false
  params = {
    venueId: '',
    tabId: '',
    passCode: '',
  }

  logo = ''
  venueName = ''

  tabDetail = {
    openDateTime: {
      date: '',
      time: '',
    },
    minAmount: 0,
    tabAmount: 0,
    currentAmount: 0,
  }

  showLoading = false
  color = '#fff'
  showCloseTab = false
  showIncreaseTab = false
  showDisableSetLimit = false
  showDisableSetLimitSettings = {
    title: t('set_limit_first', 'Set a limit first'),
    content: t('set_limit_before_share', 'You need to set a tab limit before you can share your tab with others.'),
    firstButtonText: t('set_limit', 'SET LIMIT'),
    secondButtonText: t('maybe_later', 'MAYBE LATER'),
  }

  get tabPassCode() {
    return this.$store.state.tabPassCode.tabPassCode
  }

  get isTabOpen() {
    // 0 = 刚刚建立，1 = 代表已经确认，2 = 代表已经开始，3 = 代表已经结束时间，99 = 代表完结
    return this.tabDetail && this.tabDetail.status === 2
  }

  get showTabButton() {
    // 0 = 刚刚建立，1 = 代表已经确认，2 = 代表已经开始，3 = 代表已经结束时间，99 = 代表完结
    return this.tabDetail && this.tabDetail.status >= 2
  }

  get showUpdateDetail() {
    // 0 = 刚刚建立，1 = 代表已经确认，2 = 代表已经开始，3 = 代表已经结束时间，99 = 代表完结
    return this.tabDetail && this.tabDetail.status < 2 && this.tabDetail.paymentStatus !== 3
  }

  get amountRemaining() {
    const {
      tabAmount,
      amount,
    } = this.tabDetail
    return formatDecimalNumber(parseFloat(tabAmount - amount))
  }

  get startTime() {
    if (!this.tabDetail.openDateTime) return ''
    const {
      date,
      time,
    } = this.tabDetail.openDateTime
    return `${dayjs(date).format('DD/MM/YYYY')} - ${_formatTime(time)}`
  }

  created() {
    this.$store.commit('closeLoading')
    this.timer = null
  }

  mounted() {
    this._getVenueLogo()
    this._openTabReadyDialog()
    this._getTabDetail()
  }

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }

  async _getVenueLogo() {
    const venueInfo = await getVenue({
      id: safeDecodeURI(this.$route.params.venueId)
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.logo = venueInfo.logo
    this.venueName = venueInfo.name
  }

  submitIncreaseTab(num) {
    this.showLoading = true
    updateTab({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: this.tabPassCode,
      action: 'increaseTabAmount',
      detail: {
        tabAmount: this.tabDetail.isSetTabAmount ? this.tabDetail.tabAmount + num : num,
      },
    })
      .then(_ => {
        this._getTabDetail(false)
        this.showIncreaseTab = false
        this.$createNotify({
          $props: {
            message: this.tabDetail.isSetTabAmount ? 'Your tab has been increased.' : 'Your tab limit has been set.'
          },
        }).show()
      })
      .catch(error => {
        if (error === 'tab_insufficient_fund') {
          this.$createTabMessageDialog({
            $props: tab_insufficient_fund_increase_tab,
          }).show()
        } else if (error === 'normal') {
          this.$createTabMessageDialog({
            $props: {
              ...tab_insufficient_fund_increase_tab,
              title: t('increase_tab_fail', 'Increase tab fail'),
              content: t('increase_amount_more_than_zero', 'Increase amount have to be more than 0.'),
            },
          }).show()
        }
      })
      .finally(_ => {
        this.showLoading = false
      })
  }

  goToMenu() {
    this._closeNotify()
    const tableNumber = this.routerInfo.number || this.$route.query?.tableNumber
    if (tableNumber) {
      this.$router.push(`/v/${this.venueId}/home/t/${tableNumber}`)
    } else {
      this.$router.push(`/v/${this.venueId}/home/p/`)
    }
  }

  async _fetchGetTabDetail() {
    const res = await getTabDetail({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: this.tabPassCode,
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return {
      ...res,
      tabCode: res.tabCode.toUpperCase()
    }
  }

  @loading('showLoading')
  async _getTabDetail(isPolling = true) {
    this.tabDetail = await this._fetchGetTabDetail()
    if (isPolling && !this.timer) {
      this._setIntervalGetData()
    }
  }

  _setIntervalGetData() {
    this.timer = setInterval(async _ => {
      try {
        this.tabDetail = await this._fetchGetTabDetail()
      } catch (error) {
        clearInterval(this.timer)
      }
    }, 10000)
  }

  _openTabReadyDialog() {
    const { isTabReady } = this.$route.query
    if (isTabReady) {
      const self = this
      this.$createTabMessageDialog({
        $props: ready,
        $events: {
          click() {
            self._closeNotify()
            self.$router.replace({ query: {} })
            self.showMaskTip = true
          }
        }
      }).show()
    } else {
      this.showMaskTip = false
    }
  }

  closeTab() {
    this.showLoading = true
    updateTab({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: this.tabPassCode,
      action: 'close',
    }).then(async _ => {
      this.showCloseTab = false
      this.tabDetail = await this._fetchGetTabDetail()
      const self = this
      const price = this.tabDetail.paidAmount ? formatDecimalNumber(this.tabDetail.paidAmount) : ''
      this.$createTabMessageDialog({
        $props: closeTabSuccess,
        $events: {
          click() {
            self._closeNotify()
            self.$router.push(`/v/${self.venueId}/tab-admin/${self.tabId}/order?price=${price}&email=${self.tabDetail.email}`)
          }
        }
      }).show()
    }).catch(error => {
      if (error === 'tab_insufficient_fund') {
        this.$createTabMessageDialog({
          $props: tab_insufficient_fund_payment,
        }).show()
      }
    }).finally(_ => {
      this.showLoading = false
    })
  }

  increaseAmount() {
    this.showIncreaseTab = true
  }

  showCloseTabComponent() {
    this.showCloseTab = true
  }

  updateTabDetail() {
    this.jumpToUpdateTabDetail()
  }

  jumpToUpdateTabDetail() {
    this._closeNotify()
    this.$router.push(`/v/${this.venueId}/tab-admin/${this.tabId}/update`)
  }

  jumpToTabHistory() {
    this._closeNotify()
    this.$router.push(`/v/${this.venueId}/tab-admin/${this.tabId}/history`)
  }

  handleCopy(event) {
    if (!this.tabDetail.isSetTabAmount) {
      this.showDisableSetLimit = true
    } else {
      const text = `To pay on the tab at ${this.venueName}, order from the QR code menu, select "pay with tab" and enter in the code ${this.tabDetail.tabCode}.`
      clip(text, event)
      this.$createTabMessageDialog({
        $props: tabCopyCode,
        $events: {
          click() {
            if (navigator.share) {
              navigator.share({
                title: t('share_tab_with_friends', 'Share Your Tab With Your Friends'),
                text
              }).then(() => {
                console.log('share success')
              })
                .catch(console.error)
            }
          }
        }
      }).show()
    }
  }

  _closeNotify() {
    this.$createNotify().close()
  }
}

export default TabMenu
</script>
